
/**
 * VANITY Infrastructure Configuration
 * Handles the "wiring" between Railway's environment 
 * and the frontend application logic.
 */

export const getEnv = (key: string, defaultValue: string = ''): string => {
  // 1. Check browser local storage (managed by the Atelier UI)
  if (typeof window !== 'undefined') {
    const savedConfig = localStorage.getItem('vanity_infra_config');
    if (savedConfig) {
      try {
        const parsed = JSON.parse(savedConfig);
        if (parsed[key]) return parsed[key];
      } catch (e) {
        console.error("Config Parse Error", e);
      }
    }
  }

  // 2. Check system-level environment variables (Node/Vite safe check)
  if (typeof process !== 'undefined' && process.env && (process.env as any)[key]) {
    return (process.env as any)[key];
  }

  return defaultValue;
};

export const INFRA_CONFIG = {
  // Railway PostgreSQL
  DATABASE_URL: getEnv('DATABASE_URL', 'postgresql://postgres:yvoXGRqIGgJIouQXppUaUhGgTCWZEqJk@postgres.railway.internal:5432/railway'),

  // Railway S3 Bucket (Object Storage)
  S3_ENDPOINT: getEnv('S3_ENDPOINT', 'https://storage.railway.app'),
  S3_BUCKET_NAME: getEnv('S3_BUCKET_NAME', 'tidy-pocket-mhqv7-0ihi9ad'),
  S3_ACCESS_KEY: getEnv('S3_ACCESS_KEY', 'tid_QmOyTZmEuAZPBXLsDfqLiBbEDtFaH_VGfhmgaWFniMyXJdXbYe'),
  S3_SECRET_KEY: getEnv('S3_SECRET_KEY', 'tsec_CtXKT-_N70FGjw8jyhqb-fCCXRmMsnUfRoohzQ1lrJ0Mr19kWFN30njB1q3rFzajTgjZri'),
  S3_REGION: getEnv('S3_REGION', 'auto'),

  // Resend API Key for Email OTP
  RESEND_API_KEY: "re_dUU9G97s_HajK5PuzpGL4BKAcjfJzzAvg",

  // Deployment Meta
  RAILWAY_PROJECT_ID: getEnv('RAILWAY_PROJECT_ID', '1b994268-aff2-41d0-aaf9-4bbfe2b127ee'),
  RAILWAY_SERVICE_NAME: getEnv('RAILWAY_SERVICE_NAME', 'vanity-magazine'),

  IS_PRODUCTION: typeof process !== 'undefined' && !!(process.env as any)?.RAILWAY_ENVIRONMENT,

  // Rule 2 & 9: Robust Configuration
  // If PROD, we must have a real URL. If missing, we fallback hard to avoid 'undefined' paths.
  API_URL: (() => {
    // Vite Environment Check
    const viteEnv = (typeof import.meta !== 'undefined' && import.meta.env) ? import.meta.env : {};

    // Dev Proxy check (if we are in a browser/vite context)
    if (viteEnv.DEV) return '';

    // Audit Requirement: Force Absolute URL logic
    const envUrl = viteEnv.VITE_API_URL;

    // Build Audit: Check for missing/undefined variable
    if (!envUrl || envUrl === 'undefined') {
      if (typeof window !== 'undefined') {
        console.error("🛑 VITE_API_URL is missing or 'undefined'! Defaulting to hardcoded production URL.");
      }
      return 'https://www.vanity.co.at';
    }

    return envUrl.replace(/\/$/, ''); // Remove trailing slash
  })(),
};
